import React, { useState, useEffect } from "react";
import config from "../../config";

//components
import PageTitle from "../../components/PageTitle/PageTitle";
import { CircularProgress, TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from "../modals/Modal";
import ModalMessage from "../modals/ModalMessage";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell, Select, FormControl, MenuItem,
} from "@material-ui/core";
import { Delete, RefreshRounded, Add } from "@material-ui/icons";
import Switch from "@material-ui/core/Switch";
import SnackbarMessage from "../modals/SnackbarMessage";

// styles
import useStyles from "./styles";
import useStylesTable from "../products/styles";

const Ventas = () => {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [subtotal, setSubtotal] = useState(0.00);
  const [discount, setDiscount] = useState(0.00);
  const [totalToPay, setTotalToPay] = useState(0.00);
  const [showModal, setShowModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [keyTable, setKeyTable] = useState(0);
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const [isProductExist, setIsProductExist] = useState(false);
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [costInscription, setCostInscription] = useState(null);
  const [allPaymentMethods, setAllPaymentMethods] = useState([]);
  const [payment, setPayment] = useState([]);
  const [keyChange, setKeyChange] = useState(0);
  const [paymentIndex, setPaymentIndex] = useState(0);
  const [tableKey, setTableKey] = useState(0);
  const [change, setChange] = useState(0.00);
  const [amountReceived, setAmountReceived] = useState(0.00);
  const [partnerValid, setPartnerValid] = useState(false);
  const [folio, setFolio] = useState({ text: '', valid: null });
  const [generateCode, setGenerateCode] = useState(false);
  const [manualDiscount, setManualDiscount] = useState(null);
  const [commissionPercent, setCommissionPercent] = useState(null);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const closeModalMessage = e => {
    setShowModalMessage(false);
  }

  const handleToClose = (event, reason) => {
    if ("clickaway" == reason) return;
    setShowSnackbar(false);
  };

  const fechGetProducts = async () => {
    fetch(baseUrl + "productSearch",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error != null) {
          setShowModal(true);
        } else {
          setAllProducts(data);
        }
      })
      .catch(error => null);
  }

  const fechCostInscription = async () => {
    if (!showModal) {
      fetch(baseUrl + "getInscriptionCost",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error != null) {
            setShowModal(true);
          } else {
            setCostInscription(data.cost);
          }
        })
        .catch(error => null);
    }
  }

  const fetchPaymentMethods = async () => {
    if (!showModal) {
      fetch(baseUrl + "paymentMethod",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.error != null) {
            setShowModal(true);
          } else {
            setAllPaymentMethods(data);
          }
        })
        .catch(error => null);
    }
  }

  const fechCommissionPercent = async () => {
    if (!showModal) {

      const search = {
        name: "Comisión"
      };

      fetch(baseUrl + "getOtherConcept",
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
          body: JSON.stringify(search)
        }).then(response => response.json())
        .then(data => {
          if (data.error != null) {
            setShowModal(true);
          } else {
            setCommissionPercent(data.cost);
          }
        })
        .catch(error => null);
    }
  }

  useEffect(() => {
    fechGetProducts();
    fetchPaymentMethods();
    fechCostInscription();
    fechCommissionPercent();
  }, []);

  const onSwitch = (property, valueSwitch) => (event) => {
    var indexProduct = -1;
    var product = null;

    products.map((item) => {
      if (item.id == property && item.type == "Partner") {
        indexProduct = products.indexOf(item);
        var price = item.price;
        if (valueSwitch) {
          price = price - costInscription;
        }

        product = {
          "id": item.id,
          "idProduct": item.id,
          "name": item.name,
          "type": item.type,
          "price": !valueSwitch ? (item.price + costInscription) : price,
          "discount": item.discount,
          "amount": Number(price) - Number(item.discount),
          "quantity": 1,
          "paidInscription": !valueSwitch,
          "paidBefore": item.paidBefore,
          "isPartialPayment": item.isPartialPayment,
          "penddingAmount": item.penddingAmount,
        };
      }
    });

    if (indexProduct > -1) {
      var list = products;
      list[indexProduct] = product;
      setProducts(list);

      setKeyTable(keyTable + 1);
    }

    var subtotal = 0.00;
    var discount = 0.00;

    products.map((item) => {
      subtotal = Number(subtotal) + Number((parseFloat(item.price) * parseFloat(item.quantity)));
      discount = Number(discount) + Number(parseFloat(item.discount));
    });

    setSubtotal(subtotal);
    setDiscount(discount);
    setTotalToPay(subtotal - discount);
    setKeyTable(keyTable + 1);

    var newList = payment;
    var change = 0;
    var cash = 0;
    var total = Number(subtotal - discount);
    var valid;

    for (var q = 0; q < payment.length; q++) {
      var itemPaymentList = payment[q];

      if (itemPaymentList.paymentMethod == 'Efectivo') {
        total = (Number(total) - Number(itemPaymentList.cash));
        cash = Number(cash) + Number(itemPaymentList.cash);
      } else {
        if (itemPaymentList.paymentMethod == 'Tarjeta') {
          total = (Number(total) - Number(itemPaymentList.transactionCash));
          cash = Number(cash) + Number(itemPaymentList.transactionCash);
        } else {
          total = (Number(total) - Number(itemPaymentList.transactionCash));
          cash = Number(cash) + Number(itemPaymentList.transactionCash);
        }
      }
    }

    change = Number(total) * -1;

    if (change >= 0.00) {
      change = Number(change);
    } else {
      change = 0.00;
    }

    if (cash > 0.00) {
      valid = true;
    } else {
      valid = false;
    }

    setChange(change);
    setAmountReceived(cash);
    setAmountReceived(cash);
    setPartnerValid(valid);
    setPayment(newList);
    setKeyChange(keyChange + 1);
  };

  const onSwitchCode = event => {
    setGenerateCode(!generateCode);
  };

  const onDelete = (property, type) => (event) => {
    var indexProduct = -1;

    products.map((item) => {
      if (item.id == property && item.type == type) {
        indexProduct = products.indexOf(item);
      }
    });

    if (indexProduct > -1) {
      var list = products;
      if (list.length == 1) {
        setProducts([]);
        setSubtotal(0.00);
        setDiscount(0.00);
        setTotalToPay(0.00);
        setManualDiscount(null);
        setFolio({ text: '', valid: null });
        setGenerateCode(false);
        setTableKey(tableKey + 1);
      } else {
        delete list[indexProduct];
        setProducts(list);
      }

      setKeyTable(keyTable + 1);
    }

    calculateTotalToPay();
  };

  const onSave = async e => {
    e.preventDefault();

    if (generateCode && folio.text == '') {
      setErrorSnackbar(true);
      setMessageSnackbar("No se ha definido el folio de la venta");
      setShowSnackbar(true);
    } else {
      setIsLoading(true);
      var list = [];
      var listPayment = [];
      var isPartner = false;
      var cash = 0;

      products.map((item) => {
        if (!isPartner && item.type == "Partner") {
          isPartner = true;
        }
        list.push({
          id: item.id, price: !item.paidBefore && item.paidInscription ? (Number(item.price) - Number(costInscription)).toFixed(2) : item.price.toFixed(2), type: item.type,
          amount: item.quantity, discount: item.discount.toFixed(2), isPartialPayment: item.isPartialPayment,
          paidInscription: item.paidBefore ? false : item.paidInscription
        });
      });

      for (var q = 0; q < payment.length; q++) {
        var itemPaymentList = payment[q];

        if (itemPaymentList.paymentMethod == 'Efectivo') {
          cash = Number(cash) + Number(itemPaymentList.cash);
        } else {
          cash = Number(cash) + Number(itemPaymentList.transactionCash);
        }

        listPayment.push({
          paymentMethod: itemPaymentList.paymentMethod, cash: Number(itemPaymentList.cash),
          transactionNumber: Number(itemPaymentList.transactionNumber), transactionCash: Number(itemPaymentList.transactionCash),
          commission: Number(itemPaymentList.commission == null ? "" : itemPaymentList.commission),
          totalWithCommission: Number(itemPaymentList.total == null ? "" : itemPaymentList.total)
        });
      }

      const sale = {
        idUser: localStorage.getItem('idUserSystem'), subTotal: subtotal.toFixed(2), discount: discount.toFixed(2), totalToPay: totalToPay.toFixed(2),
        change: Number(change).toFixed(2), productSaleList: list, salePayment: listPayment, folio: folio.text, generateCode: generateCode, cash: cash.toFixed(2),
        manualDiscount: Number(manualDiscount).toFixed(2)
      };

      const response = await fetch(baseUrl + "createSale", {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(sale)
      });

      const json = await response.json();
      if (json.status == "Ok") {
        setAutocompleteKey(autocompleteKey + 1);
        setProducts([]);
        setTotalToPay(0.00);
        setSubtotal(0.00);
        setDiscount(0.00);
        setPayment([]);
        setPaymentIndex(0);
        setChange(0.00);
        setAmountReceived(0.00);
        setFolio({ text: '', valid: null });
        setGenerateCode(false);
        setPartnerValid(false);
        setManualDiscount(null);

        await fetch(baseUrl + "postNewPartnerSale",
          {
            method: 'POST',
            headers: {
              'Accept': 'application/json', 'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("token")
            },
          }).then(response => response.json())
          .then(data => {
            if (data.error != null) {
              setShowModal(true);
            } else { }
          })
          .catch(error => null);

        await fetch(baseUrl + "postOpenSecondGateFromWeb",
          {
            method: 'POST',
            headers: {
              'Accept': 'application/json', 'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("token")
            },
          }).then(response => response.json())
          .then(data => {
            if (data.error != null) {
              setShowModal(true);
            } else { }
          })
          .catch(error => null);

        fechGetProducts();
      } else {
        if (json.message == "Access is denied") {
          setShowModal(true);
        }
      }

      setIsLoading(false);
    }
  }

  const onTagsChange = (event, values) => {
    if (values != null) {
      var product = {
        "id": values.id,
        "idProduct": values.id,
        "name": values.name,
        "type": values.type,
        "price": values.price,
        "discount": values.discount,
        "amount": Number(values.price) - Number(values.discount),
        "quantity": values.partialPayment == true ? values.penddingAmount : 1,
        "paidInscription": values.paidInscription,
        "paidBefore": values.paidInscription,
        "isPartialPayment": values.partialPayment,
        "penddingAmount": values.penddingAmount,
      };

      if (products.length > 0) {
        var existProduct = false;

        products.map((item) => {
          if (item.id == product.id && item.type == product.type) {
            existProduct = true;
          }
        });

        if (existProduct) {
          setIsProductExist(true);
          setShowModalMessage(true);
        } else {
          const allList = products;
          allList.push(product);
          setProducts(allList);
        }
      } else {
        const allList = products;
        allList.push(product);
        setProducts(allList);
      }

      calculateTotalToPay();
    }

    setAutocompleteKey(autocompleteKey + 1);
  }

  const handleQuantity = (id, event, type) => {
    var value = event.target.value;

    if (value > 0 && value != '') {
      var indexProduct = 0;

      for (var q = 0; q < products.length; q++) {
        var item = products[q];

        if (item.id == id && item.type == type) {
          indexProduct = products.indexOf(item);
          item.quantity = value;
          item.amount = Number(item.price) * Number(value);

          const allList = products;
          allList[indexProduct] = item;
          setProducts(allList);
          q = products.length;
        }
      }
    }

    calculateTotalToPay();
  }

  function calculateTotalToPay() {
    var subtotal = 0.00;
    var discount = 0.00;

    products.map((item) => {
      if (item.isPartialPayment) {
        subtotal = Number(subtotal) + Number(parseFloat(item.price));
      } else {
        subtotal = Number(subtotal) + Number((parseFloat(item.price) * parseFloat(item.quantity)));
      }
      discount = Number(discount) + Number(parseFloat(item.discount));
    });

    setSubtotal(subtotal);
    setDiscount(discount);
    setTotalToPay(subtotal - discount);
    setKeyTable(keyTable + 1);
  }

  const handleChange = (idPayment) => (e) => {
    const value = e.target.value;
    var newPayment;
    var indexOfPayment;
    var newPaymentList = payment;
    for (var i = 0; i < payment.length; i++) {
      var itemPayment = payment[i];

      if (itemPayment.id == idPayment) {
        newPayment = {
          id: itemPayment.id,
          paymentMethod: value,
          cash: itemPayment.cash,
          transactionNumber: itemPayment.transactionNumber,
          transactionCash: itemPayment.transactionCash,
          commission: itemPayment.commission,
          total: itemPayment.total,
        };
        indexOfPayment = payment.indexOf(itemPayment);
      }
    }

    newPaymentList[indexOfPayment] = newPayment;
    setPayment(newPaymentList);
    setKeyChange(keyChange + 1);
  }

  const onChange = (paymentMethod, idPayment) => (e) => {
    let start = e.target.selectionStart;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|\.)/, "");
    const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    e.target.value = value;

    if (val.length > 0) {
      e.target.value = Number(value).toFixed(2);
      e.target.setSelectionRange(start, start);
      var newPayment;
      var indexOfPayment;
      var newPaymentList = payment;

      for (var i = 0; i < payment.length; i++) {
        var itemPayment = payment[i];

        if (itemPayment.id == idPayment) {
          if (paymentMethod == 'Efectivo') {
            newPayment = {
              id: itemPayment.id,
              paymentMethod: itemPayment.paymentMethod,
              cash: Number(value).toFixed(2),
              transactionNumber: '',
              transactionCash: '',
              commission: null,
              total: null
            };
          } else {
            if (paymentMethod == 'Tarjeta') {
              newPayment = {
                id: itemPayment.id,
                paymentMethod: itemPayment.paymentMethod,
                cash: '',
                transactionNumber: '',
                transactionCash: Number(value).toFixed(2),
                commission: (Number(value) * (Number(commissionPercent) / 100)).toFixed(2),
                total: (Number(value) * (1 + (Number(commissionPercent) / 100))).toFixed(2),
              };
            } else {
              newPayment = {
                id: itemPayment.id,
                paymentMethod: itemPayment.paymentMethod,
                cash: '',
                transactionNumber: '',
                transactionCash: Number(value).toFixed(2),
                commission: null,
                total: null
              };
            }
          }
          indexOfPayment = payment.indexOf(itemPayment);
        }
      }

      newPaymentList[indexOfPayment] = newPayment;
      setPayment(newPaymentList);
    }
    setKeyChange(keyChange + 1);
  }

  const onChangeTransaction = (idPayment) => (e) => {
    var newPayment;
    var indexOfPayment;
    var newPaymentList = payment;

    for (var i = 0; i < payment.length; i++) {
      var itemPayment = payment[i];

      if (itemPayment.id == idPayment) {
        newPayment = {
          id: itemPayment.id,
          paymentMethod: itemPayment.paymentMethod,
          cash: itemPayment.cash,
          transactionNumber: e.target.value,
          transactionCash: itemPayment.transactionCash,
          commission: itemPayment.commission,
          total: itemPayment.total
        };
        indexOfPayment = payment.indexOf(itemPayment);
      }
    }

    newPaymentList[indexOfPayment] = newPayment;
    setPayment(newPaymentList);
    setKeyChange(keyChange + 1);
  }

  const onDeletePayment = (idPayment) => e => {
    e.preventDefault();
    var index = -1;
    payment.map((item) => {
      if (item.id == idPayment) {
        index = payment.indexOf(item);
      }
    });

    if (index > -1) {
      var list = [];
      for (var i = 0; i < payment.length; i++) {
        var item = payment[i];
        if (index != i) {
          list.push(item);
        }
      }

      var change = 0;
      var cash = 0;
      var total = Number(totalToPay);
      var valid;

      for (var q = 0; q < list.length; q++) {
        var itemPaymentList = list[q];

        if (itemPaymentList.paymentMethod == 'Efectivo') {
          total = (Number(total) - Number(itemPaymentList.cash));
          cash = Number(cash) + Number(itemPaymentList.cash);
        } else {
          if (itemPaymentList.paymentMethod == 'Tarjeta') {
            total = (Number(total) - Number(itemPaymentList.transactionCash));
            cash = Number(cash) + Number(itemPaymentList.transactionCash);
          } else {
            total = (Number(total) - Number(itemPaymentList.transactionCash));
            cash = Number(cash) + Number(itemPaymentList.transactionCash);
          }
        }
      }

      change = Number(total) * -1;

      if (change >= 0.00) {
        change = Number(change);
      } else {
        change = 0.00;
      }

      if (cash > 0.00) {
        valid = true;
      } else {
        valid = false;
      }

      setChange(change);
      setAmountReceived(cash);
      setPartnerValid(valid);
      setKeyChange(keyChange + 1);
      setPayment(list);
    }

    setTableKey(tableKey + 1);
  }

  const onAddPayment = e => {
    var newPayment = {
      id: paymentIndex,
      paymentMethod: "",
      cash: null,
      transactionNumber: null,
      transactionCash: null,
      commission: null,
      total: null
    }

    var paymentList = payment;
    paymentList.push(newPayment);

    setKeyChange(keyChange + 1);
    setPayment(paymentList);
    setPaymentIndex(paymentIndex + 1);
  }

  function calculateTotal() {
    var newList = payment;
    var change = 0;
    var cash = 0;
    var total = Number(totalToPay);
    var valid;

    if (total == 0) {
      setChange(0.00);
      setAmountReceived(0.00);
      setPartnerValid(true);
      setKeyChange(keyChange + 1);
    } else {
      for (var q = 0; q < payment.length; q++) {
        var itemPaymentList = payment[q];
  
        if (itemPaymentList.paymentMethod == 'Efectivo') {
          total = (Number(total) - Number(itemPaymentList.cash));
          cash = Number(cash) + Number(itemPaymentList.cash);
        } else {
          if (itemPaymentList.paymentMethod == 'Tarjeta') {
            total = (Number(total) - Number(itemPaymentList.transactionCash));
            cash = Number(cash) + Number(itemPaymentList.transactionCash);
          } else {
            total = (Number(total) - Number(itemPaymentList.transactionCash));
            cash = Number(cash) + Number(itemPaymentList.transactionCash);
          }
        }
      }
  
      change = Number(total) * -1;
  
      if (change >= 0.00) {
        change = Number(change);
      } else {
        change = 0.00;
      }

      if (cash > 0.00) {
        valid = true;
      } else {
        valid = false;
      }
  
      setChange(change);
      setAmountReceived(cash);
      setPartnerValid(valid);
      setPayment(newList);
      setKeyChange(keyChange + 1);
    }
  }

  function currencyFormat(num) {
    return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const handleFolio = (event) => {
    if (event.target.value != '') {
      setFolio({ text: event.target.value, valid: 'true' });
    } else {
      setFolio({ text: '', valid: 'false' });
    }
  }

  const onChangeManualDiscount = (event) => {
    var value = event.target.value;

    if (value != '') {
      setManualDiscount(value);
      setTotalToPay(Number(subtotal) - Number(discount) - Number(value));
    } else {
      setManualDiscount(0.00);
      setTotalToPay(Number(subtotal) - Number(discount));
    }

    setKeyTable(keyTable + 1);
  }

  function calculateTotalToPayAfterManualDicount() {
    setTotalToPay(Number(subtotal) - Number(discount) - Number(manualDiscount));
    setKeyTable(keyTable + 1);
  }

  return (
    <>
      <div>
        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}

        {isProductExist ? (
          <ModalMessage
            isOpen={showModalMessage}
            closeModal={closeModalMessage}
          />
        ) : (
          <></>
        )}

        <SnackbarMessage
          showSnackbar={showSnackbar}
          messageSnackbar={messageSnackbar}
          handleToClose={handleToClose}
          isError={errorSnackbar}
        />

        {isLoading ? (
          <CircularProgress size={26} className={classes.loginLoader} />
        ) : (
          <>
            <div>
              <PageTitle title="Punto de venta" />
            </div>

            <div>
              <div className={classes.divHeader} >
                <div className={classes.searchDivFullWidthWithoutShadow} >
                  <Autocomplete
                    key={autocompleteKey}
                    options={allProducts}
                    getOptionLabel={option => option.name}
                    onChange={onTagsChange}
                    className={classes.inputSearchFull}
                    openText={"Abrir"}
                    closeText={"Cerrar"}
                    clearText={"Limpiar"}
                    noOptionsText={"Sin resultados"}
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder={"Buscar producto"}
                        fullWidth
                      />
                    )}
                  />
                </div>
                <div className={classesTable.divActionButton}>
                  <RefreshRounded className={classesTable.iconAcctionInventory}
                    onClick={fechGetProducts}
                  />
                </div>
              </div>

              <div style={{ marginTop: "20px" }}></div>
              <div className={classesTable.divCard} >
                <Table className="mb-0" key={keyTable}>
                  <TableHead>
                    <TableRow className={classesTable.root} >
                      <TableCell style={{ fontSize: "14px" }} size='small' padding='none' >NOMBRE</TableCell>
                      <TableCell style={{ fontSize: "14px" }} size='small' padding='none' >CANTIDAD</TableCell>
                      <TableCell style={{ fontSize: "14px", textAlign: "center", }} size='small' padding='none' >PRECIO</TableCell>
                      <TableCell style={{ fontSize: "14px", textAlign: "center", }} size='small' padding='none' >DESCUENTO</TableCell>
                      <TableCell style={{ fontSize: "14px", textAlign: "center", }} size='small' padding='none' >IMPORTE</TableCell>
                      <TableCell style={{ fontSize: "14px", textAlign: "center", }} size='small' padding='none' >INSCRIPCIÓN</TableCell>
                      <TableCell style={{ fontSize: "14px", textAlign: "center", }} size='small' padding='none' >ACCIÓN</TableCell>
                      {/*{keys.map(key => (
                        <TableCell key={key}>{key}</TableCell>
                      ))}*/}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.map(({ id, name, price, discount, amount, quantity, type, paidInscription, paidBefore, isPartialPayment }) => (
                      <TableRow key={id}>
                        <TableCell className={classesTable.tableTextStyle} size='small' padding='none' >{name}</TableCell>
                        <TableCell className={classesTable.tableTextStyle} size='small' padding='none' >
                          <div style={{ width: "120px" }}>
                            <TextField
                              InputProps={{
                                classes: {
                                  focused: classes.textBorder,
                                  input: classes.inputForm,
                                },
                              }}
                              type="number"
                              value={quantity}
                              onChange={(event) => handleQuantity(id, event, type)}
                              name={"quantity"}
                              disabled={isPartialPayment == true ? true : false}
                            />
                          </div>
                        </TableCell>
                        <TableCell className={classesTable.centerTextStyle} size='small' >{currencyFormat(price)}</TableCell>
                        <TableCell className={classesTable.centerTextStyle} size='small' >{currencyFormat(discount)}</TableCell>
                        <TableCell className={classesTable.centerTextStyle} size='small' >{currencyFormat(amount)}</TableCell>
                        <TableCell className={classesTable.centerTextStyle} size='small' >
                          {type == "Partner" ? (
                            <>
                              {!paidBefore ? (
                                <div>
                                  <div className={classesTable.divSwitch}>
                                    <p style={{ marginRight: "8px", fontSize: "16px", }}>No</p>
                                    <Switch
                                      checked={paidInscription}
                                      onChange={onSwitch(id, paidInscription)}
                                      inputProps={{ "aria-label": "controlled" }}
                                    />
                                    <p style={{ marginLeft: "8px", fontSize: "16px", }}>Si</p>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <p>Pagada</p>
                                </>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </TableCell>
                        <TableCell className={classesTable.tableTextStyle} size='small' padding='none' >
                          <div>
                            <div className={classesTable.divActionButton}>
                              <Delete className={classesTable.iconAcctionInventory}
                                onClick={onDelete(id, type)}
                              />
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div className={classesTable.divCard} key={tableKey} >
                  <div className={classes.divColumnPay} >
                    <text className={classes.titlePayTextStyle} >SubTotal:</text>
                    <text className={classes.subtitlePayTextStyle} >{currencyFormat(subtotal)}</text>
                    <text className={classes.titlePayTextStyle} >Descuento en membrecía:</text>
                    <text className={classes.subtitlePayTextStyle}>{currencyFormat(discount)}</text>
                    <text className={classes.titlePayTextStyle}>Descuento extra:</text>
                    <div style={{ display: "flex" }}>
                      <text style={{ fontSize: "16px", marginTop: "8px" }}> $ </text>
                      <TextField
                        InputProps={{
                          classes: {
                            focused: classes.textBorder,
                            input: classes.inputPayGroup,
                          },
                        }}
                        disabled={products.length == 0 ? true : false}
                        value={manualDiscount}
                        onChange={(event) => onChangeManualDiscount(event)}
                        placeholder={"0.00"}
                        onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                        onKeyUp={calculateTotalToPayAfterManualDicount}
                        onBlur={calculateTotalToPayAfterManualDicount}
                        style={{ width: '75%' }}
                        inputStyle={{ width: '75%' }}
                      />
                    </div>
                    <text className={classes.titlePayTextStyle}>Total:</text>
                    <text className={classes.subtitlePayTextStyle}>{currencyFormat(totalToPay)}</text>
                  </div>

                  <Table className="mb-0">
                    <TableHead>
                      <TableRow className={classes.rootTable} >
                        <TableCell size='small' padding='none' style={{ textAlign: "center" }} >Método</TableCell>
                        <TableCell size='small' padding='none' style={{ textAlign: "center" }} >Cantidad</TableCell>
                        <TableCell size='small' style={{ textAlign: "center" }} >Comisión</TableCell>
                        <TableCell size='small' style={{ textAlign: "center" }} >Total</TableCell>
                        <TableCell size='small' padding='none' style={{ textAlign: "center" }} >Transacción</TableCell>
                        <TableCell size='small' padding='none' ></TableCell>
                        {/*{keys.map(key => (
                          <TableCell key={key}>{key}</TableCell>
                        ))}*/}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payment.map(({ id, paymentMethod, cash, transactionNumber, transactionCash, commission, total }) => (
                        <TableRow>
                          <TableCell className={classes.tableRowStyleTitle} size='small' padding='none' >
                            <FormControl className={classes.formControlSale}>
                              <Select
                                onChange={handleChange(id)}
                                displayEmpty
                                style={{ color: "#000", backgroundColor: "#fff" }}
                                value={paymentMethod}
                              >
                                <MenuItem value=""> Selecciona </MenuItem>
                                {allPaymentMethods.map((option) => (
                                  <MenuItem value={option.name}>{option.name}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell className={classes.tableRowStyleTitle} size='small' padding='none' >
                            <div style={{ display: "flex", alignItems: "end", backgroundColor: "#fff", padding: "12px" }}>
                              <TextField
                                InputProps={{
                                  classes: {
                                    focused: classes.textBorderInvert,
                                    input: classes.inputPayGroupInvert,
                                  },
                                }}
                                value={paymentMethod != "Efectivo" && paymentMethod != "" ? transactionCash : cash}
                                disabled={paymentMethod == "" ? true : false}
                                onChange={onChange(paymentMethod, id)}
                                placeholder={"0"}
                                onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                onKeyUp={calculateTotal}
                                onBlur={calculateTotal}
                                style={{ width: '75%' }}
                                inputStyle={{ width: '75%' }}
                              />
                              {paymentMethod != "Tarjeta" ? (
                                <></>
                              ) : (
                                <text style={{ fontSize: "16px", color: "#000" }}>{" * " + commissionPercent + "%"}</text>
                              )}
                            </div>
                          </TableCell>
                          <TableCell className={classes.tableRowStyleTitle} size='small' style={{ textAlign: "center" }} >
                            {commission == null ? (
                              <></>
                            ) : (
                              <>
                                {currencyFormat(Number(commission))}
                              </>
                            )}
                          </TableCell>
                          <TableCell className={classes.tableRowStyleTitle} size='small' style={{ textAlign: "center" }} >
                            {total == null ? (
                              <></>
                            ) : (
                              <>
                                {currencyFormat(Number(total))}
                              </>
                            )}
                          </TableCell>
                          <TableCell className={classes.tableRowStyleTitle} size='small' padding='none' >
                            <div style={{ display: "flex", alignItems: "end", backgroundColor: "#fff", padding: "12px" }}>
                              <TextField
                                InputProps={{
                                  classes: {
                                    focused: classes.textBorderInvert,
                                    input: classes.inputPayGroupInvert,
                                  },
                                }}
                                value={transactionNumber}
                                onChange={onChangeTransaction(id)}
                                placeholder={"0"}
                                disabled={paymentMethod == "Efectivo" || paymentMethod == "" ? true : false}
                                onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                onKeyUp={calculateTotal}
                                onBlur={calculateTotal}
                                style={{ width: '75%' }}
                                inputStyle={{ width: '75%' }}
                              />
                            </div>
                          </TableCell>
                          <TableCell className={classes.tableRowStyleTitle} size='small' padding='none' >
                            <div className={classes.divActionButtonDisable} >
                              <Delete
                                classes={{ root: classes.searchIconSale }}
                                onClick={onDeletePayment(id)}
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell className={classes.tableRowStyleTitle} >
                          <div className={classes.divAddButtonSale}>
                            <Add classes={{ root: classes.searchIconSale }}
                              onClick={onAddPayment}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>

                  <div className={classes.divColumnPay} >
                    <text className={classes.titlePayTextStyle}>Importe recibido:</text>
                    <text className={classes.titlePayTextStyle}>{currencyFormat(amountReceived)}</text>
                    <text className={classes.titlePayTextStyle}>Cambio:</text>
                    <text className={classes.titlePayTextStyle}>{currencyFormat(change)}</text>
                    <text className={classes.titlePayTextStyle}>Folio:</text>
                    <TextField
                      InputProps={{
                        classes: {
                          focused: classes.textBorder,
                          input: classes.inputPayGroup,
                        },
                      }}
                      disabled={products.length == 0 ? true : false}
                      value={folio.text}
                      onChange={(event) => handleFolio(event)}
                      placeholder={"folio"}
                      style={{ width: '75%' }}
                      inputStyle={{ width: '75%' }}
                    />

                    <p className={classes.titlePayTextStyle}>¿Generar código para el 2do acceso?</p>
                    <div>
                      <div className={classesTable.divSwitch}>
                        <p style={{ marginRight: "8px", fontSize: "14px", }}>No</p>
                        <Switch
                          disabled={products.length == 0 ? true : false}
                          checked={generateCode}
                          onChange={onSwitchCode}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                        <p style={{ marginLeft: "8px", fontSize: "14px", }}>Si</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={classes.divButton}>
                  {isLoading ? (
                    <div className={classes.loginLoader} >
                      <CircularProgress size={26} />
                    </div>
                  ) : (
                    <button
                      className={partnerValid == true ?
                        classes.enableButton : classes.disableButton}
                      disabled={!(partnerValid == true)}
                      onClick={onSave}
                    >PAGAR</button>
                  )}
                </div>
              </div>

            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Ventas;
